<template>
  <div class="cmp-royalty-accounts-accounts_list dt-page">
    <div class="dt-page--top-bar v1">
      <div class="dt-page--add-button">
        <div class="dt-icon-container">
          <img
            @click="onAddAccountListClick"
            class="dt-icon v5 s1"
            src="static/buttons/add.svg"
            alt
          />
        </div>
      </div>
      <div class="search" style="max-width: 330px">
        <InputField
          :value="basicFilter.searchString"
          :placeholder="'Search'"
          :config="{
            borderStyle: 'bottom',
            maxWidth: '200px',
            minWidth: '200px',
            width: '200px',
          }"
          @keyup="onSearchInputKeyup"
        ></InputField>
        <DTIconButton
          :classNames="'search--advanced'"
          :text="'Advanced Search'"
          :style="{
            minWidth: '148px',
          }"
          icon="add-blue"
          @click="onAdvancedSearchClick"
        />
      </div>
      <div class="search-config--container">
        <div class="search-config">
          <SearchConBadge
            v-for="sconKey of filteredAdvancedSearchConfigKeys"
            :key="sconKey"
            v-bind="searchConfigKey(sconKey)"
            @delete="onSearchConDelete"
          />
        </div>
      </div>
    </div>
    <div class="dt-page--body">
      <NTable
        class="h1"
        :headers="headers"
        :config="tableConfig"
        :items="list"
        :loadingFlag="loadingFlag"
        @scrollnext="onListScroll"
        :id="'royalty-accounts-accounts_list'"
      >
        <template v-slot:item="{ item, tdcon }">
          <tr
            @click="onAccountClicked(item)"
            :class="{
              selected: selectedRow(item),
            }"
          >
            <td v-bind="tdcon('royalty_account_name')">
              <div class="ut-flex">
                <DtStatus
                  :statusTVList="statusTV"
                  :item="getItemForStatus(item)"
                  @updateStatus="onStatusChange"
                />
                <div
                  class="txtov"
                  :title="item['royalty_account_name']"
                  style="font-weight: bold; margin-left: 4px"
                >
                  <b> {{ item["royalty_account_name"] }}</b>
                </div>
              </div>
            </td>
            <td v-bind="tdcon('royalty_period_txt')">
              <span class="txtov" :title="item['royalty_period_txt']">{{
                item["royalty_period_txt"]
              }}</span>
            </td>
            <td v-bind="tdcon('contact_name')" :title="item['contact_name']">
              <span class="txtov">{{ item["contact_name"] }}</span>
            </td>
            <td v-bind="tdcon('city')">
              <span>{{ item["city"] }} </span>
            </td>
            <td v-bind="tdcon('email')">
              <span>{{ item["email1"] }} </span>
            </td>
            <td v-bind="tdcon('options')">
              <img
                v-if="item['not_deletable']"
                src="static/icons/delete.svg"
                @click.stop="(e) => onAccountDelete(item)"
                class="dt-icon v5 s2 ut-center"
                alt
              />
            </td>
          </tr>
        </template>
      </NTable>
    </div>
    <div class="account-list-footer">
      <!-- <DtPageStatus :statusTV="statuses" /> -->
      <DtPageStatusFloat :statusTV="statusTV" />
    </div>
    <ModalContainer :modalKey="'advancedSearch'" width="450">
      <AdvancedSearch
        :advancedSearchData="advancedSearchData"
        :initSearchFilter="searchFilter"
        @search="onAdvancedSearch"
        @cancelled="onDialogCancelled"
      />
    </ModalContainer>
    <Sidewindow
      :navConfig="defaultConfig"
      :value="accountDetailsFlag"
      @closed="onCloseAccountDetails"
    >
      <AccountsSidewindow />
    </Sidewindow>
    <ModalContainer :modalKey="'newAccount'" :width="'small'">
      <NewAccount @cancelled="onDialogCancelled" @added="onAdded" />
    </ModalContainer>
    <ModalContainer :modalKey="'deleteAccountModal'" :width="'small'">
      <DeleteAccountModal @cancelled="onDialogCancelled" />
    </ModalContainer>
  </div>
</template>

<script>
import { createLDTHost } from "@/dt-plugins/sidewindow/LDTHost.mixin";
import NTable from "@/plugins/datatable/datatable";
import { Subject } from "rxjs";
import InputField from "@plugins/text-field/input-field";
import {
  childOfOrEqualDetails,
  handleFromRoute,
} from "../../../../utility/route";

import * as ActionTypes from "../../store/types";
import { RoyaltyStoreNamespace as storeNS } from "../../store";

import {
  createModalMixin,
  openModalRoute,
} from "../../../../dt-plugins/modal/modal.mixin";
import { mapGetterObject, mapActionObject } from "../../../../store/global";
import ModalContainer from "@dtplugins/modal/modal-container";
import DTCheckbox from "../../../../plugins/checkbox/checkbox";
import {
  subscribeSubject,
  subscribeSubjectND,
  openWindow,
} from "../../../../utility";
import {
  getAccountsDetailsSelectable,
  royaltyAccountsListLDTRoutes,
} from "../../router/routes";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";

import { accountsRoyaltyActions } from "../../store/accounts/actions";
// import AccountsSidewindow from "./accounts-sidewindow";
import { accountsRoyaltyGetters } from "../../store/accounts/getters";
import { createAdvancedSearchConfig } from "../../../../dt-plugins/advanced-search/advanced-search.model";
import { LoadedEnd } from "../../../../dt-plugins/advanced-search/load.model";
import { createFetchListMixin } from "../../../../dt-plugins/advanced-search/fetch-list.mixin";
import { AccountsService } from "../../services/accounts.service";
import { DTIconButton } from "../../../../plugins/button/button";
import { createTV, createTVI, tv } from "../../../../models/text-value.model";
import { defaultConfig } from "@/dt-plugins/sidewindow/config.model";
import { createAdvancedSearchHost } from "../../../../dt-plugins/advanced-search/advance-search.mixin";
import AdvancedSearch from "./advanced-search.vue";
import { accountListAdvancedSearchConfig } from "./advanced-search.vue";
import {
  ConfirmationService,
  createConfirmResult,
} from "@/dt-plugins/confirmation/confirmation.service";
import AccountsSidewindow from "./accounts-sidewindow.vue";
import NewAccount from "./new-account.vue";
import DeleteAccountModal from "./delete-account-modal.vue";
import DtPageStatus from "@dtplugins/dtpage-status/dtpage-status";
import DtPageStatusFloat from "@dtplugins/dtpage-status/dtpage-status-float";
import DtStatus from "@dtplugins/dt-status-dropdown/dt-status";
import { async } from "ramda-adjunct";
import { createSubmoduleListMixin } from "../../../../dt-plugins/submodule-list/submodule-list.mixin";
const LDTConfig = {
  entityName: "account",
  ldtRoutes: royaltyAccountsListLDTRoutes,
  detailsSelectableFunction: getAccountsDetailsSelectable,
  primaryKey: "royalty_account_id",
  storeNs: storeNS,
  SELECT_ACTION: ActionTypes.AccountsDetails.FETCH.SINGLE,
  SELECT_AUTO_ACTION: ActionTypes.AccountsDetails.FETCH.SINGLE,
};

export default {
  components: {
    ModalContainer,
    NTable,
    InputField,
    DTCheckbox,
    DTIconButton,
    AdvancedSearch,
    AccountsSidewindow,
    NewAccount,
    DtPageStatus,
    DtPageStatusFloat,
    DeleteAccountModal,
    DtStatus,
  },
  data: () => ({
    defaultConfig: defaultConfig,
    getAccountsDetailsSelectable: getAccountsDetailsSelectable,
    selectedClickedAccount: null,
  }),
  mixins: [
    createLDTHost(LDTConfig),
    createModalMixin("advancedSearch"),
    createModalMixin("newAccount"),
    createModalMixin("deleteAccountModal"),

    createFetchListMixin(ActionTypes.AccountsList.FETCH.ALL, 50, {
      advancedSearchable: true,
      searchable: true,
      scrollable: true,
    }),
    createAdvancedSearchHost(accountListAdvancedSearchConfig),
    createSubmoduleListMixin("royalty_account", "royalty_account_id"),
  ],
  computed: {
    ...mapGetterObject(storeNS, accountsRoyaltyGetters),

    tableConfig: () =>
      createNTableConfig({
        fullHeight: true,
        rowHeight: 40,
      }),
    statusTVList: function () {
      return (
        this.advancedSearchResponse?.label_statuses?.map((e) => {
          return {
            text: e["label_status_name"],
            value: e["label_status_colour"],
            id: e["label_status_id"],
          };
        }) || []
      );
    },
    statusTV: function () {
      return (
        createTVI(
          this.advancedSearchResponse?.label_statuses,
          "label_status_name",
          "label_status_colour",
          "label_status_id"
        ) || []
      );
    },
    list: function () {
      return this.accountsList?.royalty_accounts || [];
    },
    // statuses: function () {
    //   return this.advancedSearchResponse?.label_statuses || [];
    // },
    statuses: function () {
      return (
        createTV(
          this.advancedSearchResponse?.label_statuses || [],
          "label_status_name",
          "label_status_colour"
        ) || []
      );
    },
    headers: () => [
      createTableHeader("royalty_account_name", { f: 3 }),
      createTableHeader("royalty_period", { f: 1 }),
      createTableHeader("contact"),
      createTableHeader("city"),
      createTableHeader("email"),
      createTableHeader("options", { text: false, mw: 40 }),
    ],
    accountDetailsFlag: function () {
      return childOfOrEqualDetails(royaltyAccountsListLDTRoutes, this.$route);
    },
    filter: function () {
      return {
        ...this.metaFilter,
        basicFilter: this.basicFilter,
        searchFilter: this.searchFilter,
      };
    },
    advancedSearchData: function () {
      return {
        account_basesTV: createTV(
          this.advancedSearchResponse?.account_bases,
          "label",
          "value"
        ),
        companiesTV: createTV(
          this.advancedSearchResponse?.companies,
          "company_name",
          "company_id"
        ),
        countriesTV: createTV(
          this.advancedSearchResponse?.countries,
          "country_fullname",
          "country_fullname"
        ),
        currenciesTV: createTV(
          this.advancedSearchResponse?.currencies,
          "currency_iso",
          "currency_id"
        ),
        invoice_projectsTV: createTV(
          this.advancedSearchResponse?.invoice_projects,
          "invoice_project_name",
          "invoice_project_id"
        ),
        label_statusesTV: createTV(
          this.advancedSearchResponse?.label_statuses,
          "label_status_name",
          "label_status_id"
        ),
        royalty_periodsTV: createTV(
          this.advancedSearchResponse?.royalty_periods,
          "label",
          "value"
        ),
        tax_typesTV: createTV(
          this.advancedSearchResponse?.tax_types,
          "tax_name",
          "tax_type_id"
        ),
        vat_typesTV: createTV(
          this.advancedSearchResponse?.vat_types,
          "vat_type_name",
          "vat_type_id"
        ),
        statement_TypeTV: [
          { text: "Send manually", value: "1" },
          { text: "Send automatically", value: "2" },
          { text: "Don't send", value: "3" },
        ],

        label_statusesTV: createTV(
          this.advancedSearchResponse?.label_statuses || [],
          "label_status_name",
          "label_status_id"
        ),
        label_statuses: this.advancedSearchResponse?.label_statuses || [],
      };
    },
  },
  methods: {
    ...mapActionObject(storeNS, accountsRoyaltyActions),
    getItemForStatus: function (item) {
      return {
        itemID: item.royalty_account_id,
        colorPropertyName: "label_status_id",
        colorPropertyValue: item.label_status_id,
        colorName: "label_status_colour",
        colorValue: this.statusTV?.find((x) => x.id === item.label_status_id)?.value,
      };
    },
    getAccountStatColor(payload = "") {
      // console.log(payload);
      const color_map = {
        "4A6CBA": "4A6CBA",
        "5ABFBF": "5ABFBF",
        F0ED56: "F0ED56",
      };

      return color_map[payload];
    },
    defaultBasicFilter() {
      return {
        searchString: undefined,
      };
    },
    refresh: function () {
      this.fetchListNext();
    },
    onAdvancedSearchClick: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "advanced_search",
        },
      });
    },
    onAdded: function (payload) {
      this.refresh();
      this.onDialogCancelled();
    },
    onDialogCancelled: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: undefined,
        },
      });
    },
    onAddAccountListClick: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "new_account",
        },
      });
    },

    // NEW
    fetchAdvancedSearchData: async function () {
      const advancedSearchData = await AccountsService.advancedSearch();
      if (advancedSearchData) {
        this.advancedSearchResponse = advancedSearchData.data;
        // console.log("advancedSearchData", advancedSearchData);
      }
    },

    onAccountDelete: async function (item) {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "delete_account_modal",
          royalty_account_id: item.royalty_account_id,
        },
      });
    },

    onAccountMailClick: function (item) {
      location.href = `mailto: ${item.email1}`;
    },
    onAccountPreview: function (item) {
      openWindow(item.bundle_preview_link, "_blank", { wr: 0.7, hr: 0.7 });
    },
    onAccountVerifyUser: function (item) {
      openWindow(item.bundle_public_link, "_blank", { wr: 0.7, hr: 0.7 });
    },
    // Start Sidewindow
    onAccountClicked: function (account) {
      this.selectedClickedAccount = account;
      this.$router.push({
        name: royaltyAccountsListLDTRoutes.names.tab,
        params: {
          royalty_account_id: account.royalty_account_id,
          tab: "overview",
        },
      });
    },
    onCloseAccountDetails: function () {
      this.selectedClickedAccount = null;
      handleFromRoute(this, () => {
        this.$router.push({
          name: royaltyAccountsListLDTRoutes.names.list,
        });
      });
    },
    onStatusChange: function (payload) {
      //const item = this.selectedReleaseDetails;
      // this[ActionTypes.AccountsList.UPDATE.SINGLE](payload);

      const {
        itemID,
        colorPropertyName,
        colorName,
        colorPropertyValue,
        colorValue,
      } = payload;

      this[ActionTypes.AccountsList.UPDATE.SINGLE]({
        kVal: itemID,
        name: "label_status_id",
        value: colorPropertyValue,
      });

      //console.log(payload,payload)
    },
    //MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-royalty-accounts-accounts_list {
  .dt-page--body {
    --offset: 160px;
  }
  .dt-page--top-bar {
    .search {
      .dt-checkbox-control {
        .dt-checkbox-label {
          color: var(--text-accent);
          font-weight: 500;
        }
      }
    }
  }
  .account-list-footer {
    //border-top: 1px solid var(--sprt-5);
    padding: 0 10px;

    .status-list {
      .status {
        margin-top: 15px;
        max-width: 110px;
      }
    }
  }
}

.status {
  // flex: 1;
  display: flex;
  align-items: center;
  max-width: 150px;
  .circle-status {
    margin-right: 10px;
  }
  .status-name {
    flex: 1;
  }
}
</style>
